<template>
  <div class="record">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      警报列表
    </div>
    <div class="searchBox">
      <el-form ref="dataForm" :model="dataForm">
        <el-form-item>
          <el-date-picker
            v-model="dataForm.startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dataForm.endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="recodList"
      v-loading="loading"
      element-loading-text="拼命加载中..."
      v-loading.lock="true"
      v-infinite-scroll="loadMore"
    >
      <div
        v-for="(item, index) in dataList"
        :key="index"
        class="msgBox"
        @click="jumpToDetail(item)"
      >
        <div class="msgHead">
          <h5>{{ item.flowMeterName }}</h5>
          <p>{{ item.createTime }}</p>
        </div>
        <div class="msgMain">
          <div class="msgMainLabel">警报描述:</div>
          <div class="msgMainValue">{{ item.description }}</div>
        </div>
        <div class="msgMain" v-if="item.isComfirm === 1">
          <div class="msgMainLabel">警报确认人:</div>
          <div class="msgMainValue">{{ item.confirmUserName }}</div>
        </div>
        <div class="msgMain" v-if="item.isComfirm === 1">
          <div class="msgMainLabel">警报确认时间:</div>
          <div class="msgMainValue">{{ item.confirmTime }}</div>
        </div>
        <div class="msgFooter">
          详情 >
        </div>
      </div>
      <div class="loadFinish" v-if="dataList.length === totalCount && dataList.length != 0">已经没有更多的信息了</div>
      <div class="no-order" v-if="dataList.length == 0">
        <span>未查询到符合条件的工单</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      popstateLock: 0,//是否监听物理返回键
      dataForm: {
        startDate: moment(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD")
      },
      dataList: [],
      page: 1,
      limit: 3,
      totalPage: 0,
      totalCount: 0,
      loading: true
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate();
      }else{
        this.removePopstate();
      }
    }
  },
  created() {
    this.getQuery();
  },
  mounted() {
    this.addPopstate(); //在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate();
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回首页
    backIndex() {
      this.$router.push({ name: 'Index' })
    },
    // 加载更多
    async loadMore() {
      this.loading = false;
      if (this.totalCount > this.dataList.length) {
        this.page = this.page + 1;
        // 根据获取的数据请求符合条件的工单
        await this.$http.httpGet('/app/tbAlarmRecord/list', {
          page: this.page,
          limit: this.limit,
          startDate: this.dataForm.startDate,
          endDate: this.dataForm.endDate
        }).then(res => {
          if (res && res.code === 0) {
            this.dataList = this.dataList.concat(res.page.list);
            this.totalCount = res.page.totalCount;
          } else {
            this.dataList = [];
            this.totalCount = 0;
            this.$message.error('获取数据失败: ' + res.msg)
          }
        }).catch(() => {
          this.loading = false;
        })
      }
    },
    jumpToDetail(data) {
      this.$cookies.set("warningDetail", data);
      this.$router.push({ name: 'details', query: {id: data.id}})
    },
    // 获取到传过来的参数
    async getQuery () {
      this.dataList = [];
      this.page = 1;
      this.loading = true;
      // 根据获取的数据请求符合条件的工单
      await this.$http.httpGet('/app/tbAlarmRecord/list', {
        page: this.page,
        limit: this.limit,
        startDate: this.dataForm.startDate,
        endDate: this.dataForm.endDate
      }).then(res => {
        this.loading = false;
        if (res && res.code === 0) {
          this.dataList = res.page.list;
          this.totalCount = res.page.totalCount;
        } else {
          this.dataList = [];
          this.totalCount = 0;
          this.$message.error('获取数据失败: ' + res.msg)
        }
      }).catch(() => {
        this.loading = false;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.no-order {
  padding-top: 3rem;
  text-align: center;
  span {
    font-size: 1.8rem;
  }
}
.record ::v-deep {
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #409eff;
    height: 50px;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .searchBox {
    padding: 60px 0 0;
    position: relative;
    border-bottom: 1px #efefef solid;
    .el-form {
      padding: 0 15px;
      margin: 0;
      position: relative;
      .el-form-item {
        margin: 0 0 15px;
        .el-form-item__content {
          width: 100%;
          .el-date-editor.el-input {
            width: 100%;
          }
          .el-button {
            width: 100%;
          }
        }
      }
    }
  }
  .loadFinish {
    padding: 10px 0;
    text-align: center;
    color: #999;
    font-size: 14px;

  }
  .recodList {
    padding: 0;
    position: relative;
    height: calc(100vh - 241px);
    overflow-x: hidden;
    overflow-y: auto;
    .msgBox {
      width: calc(100% - 30px);
      margin: 15px 15px 0;
      position: relative;
      overflow: hidden;
      background-color: #dfdfdf;
      border-radius: 6px;
      .msgHead {
        border-bottom: 1px #ccc solid;
        padding: 8px 15px;
        color: #000;
        line-height: 1.4;
        h5 {
          font-size: 20px;
          display: block;
          line-height: 1.8;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0;
          margin: 0;
        }
        p {
          font-size: 14px;
          color: #999;
          margin: 0;
          padding: 0;
        }
      }
      .msgMain {
        position: relative;
        padding: 15px;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        .msgMainLabel {
          width: 90px;
          padding: 0 5px 0 0;
          font-size: 14px;
          color: #000;
          text-align: right;
        }
        .msgMainValue {
          flex: 1;
          color: #666;
          font-size: 14px;
          word-break: break-all;
        }
        + .msgMain {
          padding: 0 15px 15px;
        }
      }
      .msgFooter {
        border-top: 1px #ccc solid;
        padding: 8px 15px;
        font-size: 14px;
        text-align: right;
      }
    }
  }
}

</style>
